export default "__VITE_ASSET__D28E6Uuh__"